// extracted by mini-css-extract-plugin
export var location = "loc-mod--location--KPT4_";